import { UIKitIcon } from '../icon';

export const mailIcon: UIKitIcon = {
  name: 'mail',
  data: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M26 8H6v16h20V8Z" stroke-linejoin="round"/><path d="m18.5 16 7.5 8H6l7.5-8" stroke-linejoin="round"/><path d="M16 18 6 8h20L16 18Z" stroke-linejoin="round"/></svg>',
};
